import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { exhaustMap, map, catchError, of, tap } from "rxjs";
import { DataService } from "src/app/services/data.service";
import { NotificationService } from "src/app/services/notification-service/notification.service";
import { getAllHistoriqueScan, getAllHistoriqueScanSuccess, getAllHistoriqueScanFailure, createHistoriqueScan, createHistoriqueScanSuccess, createHistoriqueScanFailure } from "../actions/historiqueScan.action";

@Injectable()
export class HistoriqueScanEffect {

  loadHistoriqueScans$ = createEffect(() => this.actions$.pipe(
    ofType(getAllHistoriqueScan),
    exhaustMap(({ element, page, size }) => this.dataService.loadData(element, page, size).pipe(
      map((responseDAO) => getAllHistoriqueScanSuccess(responseDAO)),
      catchError((error) => of(getAllHistoriqueScanFailure(error)))
    ))
  ))

  createHistoriqueScan$ = createEffect(() => this.actions$.pipe(
    ofType(createHistoriqueScan),
    exhaustMap(({ historiqueScan }) => this.dataService.createObject("HistoriqueScan", historiqueScan).pipe(
      map((responseDAO) => createHistoriqueScanSuccess(responseDAO)),
      catchError((error) => of(createHistoriqueScanFailure(error)))
    )),
    tap((action) => {
      if (action.type == "[HistoriqueScan] create Historique Scan Success") {
        this.notificationService.success("Scan Historisé avec succès")
      }
    }
    )
  ))
  constructor(private actions$: Actions, private dataService: DataService, private notificationService: NotificationService) { }
}